'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toggleItemSave = exports.isItemSaved = exports.getSortedSavedItemIdsFromState = exports.getSavedItem = exports.UNSAVE_ITEM_SUCCESS = exports.UNSAVE_ITEM_REQUEST = exports.UNSAVE_ITEM_FAIL = exports.SAVE_ITEM_SUCCESS = exports.SAVE_ITEM_REQUEST = exports.SAVE_ITEM_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = reducer;

var _item = require('../modules/item');

var _user = require('../modules/user');

var _analytics = require('../modules/analytics');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _config = require('../modules/config');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _login = require('../modules/login');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var SAVE_ITEM_FAIL = exports.SAVE_ITEM_FAIL = 'la/user/saveItem/FAIL';
var SAVE_ITEM_REQUEST = exports.SAVE_ITEM_REQUEST = 'la/user/saveItem/REQUEST';
var SAVE_ITEM_SUCCESS = exports.SAVE_ITEM_SUCCESS = 'la/user/saveItem/SUCCESS';

var UNSAVE_ITEM_FAIL = exports.UNSAVE_ITEM_FAIL = 'la/user/unsaveItem/FAIL';
var UNSAVE_ITEM_REQUEST = exports.UNSAVE_ITEM_REQUEST = 'la/user/unsaveItem/REQUEST';
var UNSAVE_ITEM_SUCCESS = exports.UNSAVE_ITEM_SUCCESS = 'la/user/unsaveItem/SUCCESS';

// reducer
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;

    switch (action.type) {
        case _user.LOAD_BIDDER_DATA_SUCCESS:
        case _login.LOGIN_SUCCESS:
            existing = {};
            if (action.payload.savedItemsTime) {
                action.payload.savedItemsTime.forEach(function (item) {
                    existing[item.itemId] = { itemId: Number(item.itemId), saveTs: item.saveTs };
                    existing[item.itemId].status = 'SAVED';
                });
            }
            return existing;

        case _user.LOG_OUT_BIDDER:
            // reset saved Items to defaults
            return DEFAULT_STATE;

        case SAVE_ITEM_FAIL:
            existing = (0, _cloneDeep2.default)(state);
            delete existing[action.meta.itemId];
            return existing;

        case UNSAVE_ITEM_REQUEST:
            existing = (0, _cloneDeep2.default)(state);
            existing[action.payload].status = 'REMOVED';
            return existing;

        case UNSAVE_ITEM_SUCCESS:
            return state;

        case SAVE_ITEM_REQUEST:
            existing = (0, _cloneDeep2.default)(state);
            existing[action.payload.itemId] = {
                itemId: action.payload.itemId,
                saveTs: action.payload.saveTs,
                status: 'SAVED'
            };
            return existing;

        case SAVE_ITEM_SUCCESS:
            return state;

        case UNSAVE_ITEM_FAIL:
            existing = (0, _cloneDeep2.default)(state);
            existing[action.meta.itemId].status = 'SAVED';
            return existing;

        default:
            return state;
    }
}

/* SELECTORS */
var saveItemSelector = function saveItemSelector(state) {
    return state.user.saveItem;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var savedItemsSelector = (0, _reselect.createSelector)(saveItemSelector, function (saveItems) {
    return saveItems;
});

var getSavedItem = exports.getSavedItem = (0, _reselect.createSelector)([savedItemsSelector, idSelector], function (savedItems, id) {
    return savedItems[id] || {};
});

var getSortedSavedItemIdsFromState = exports.getSortedSavedItemIdsFromState = (0, _reselect.createSelector)(savedItemsSelector, function (savedItems) {
    var toBeSorted = (0, _keys2.default)(savedItems).map(function (item) {
        return savedItems[item];
    });
    var sorted = toBeSorted.sort(function (a, b) {
        return b.saveTs - a.saveTs;
    });
    return sorted.map(function (item) {
        return item.itemId;
    });
});

var isItemSaved = exports.isItemSaved = (0, _reselect.createSelector)(getSavedItem, function (savedItem) {
    return savedItem.status === 'SAVED';
});

/* ACTION CREATORS */
var saveItemFail = function saveItemFail(itemId, error) {
    return {
        error: true,
        meta: { itemId: itemId },
        payload: error,
        type: SAVE_ITEM_FAIL
    };
};

var saveItemRequest = function saveItemRequest(itemId) {
    return {
        payload: { itemId: itemId, saveTs: Date.now() },
        type: SAVE_ITEM_REQUEST
    };
};

var saveItemSuccess = function saveItemSuccess(itemId, savedItemAnalytics) {
    return {
        meta: savedItemAnalytics,
        payload: itemId,
        type: SAVE_ITEM_SUCCESS
    };
};

var submitSaveItem = function submitSaveItem(itemId) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch(saveItemRequest(itemId));
        return _api.SaveItem.postSaveItem({ authToken: authToken, deployment: deployment, itemId: itemId }).then(function () {
            var promises = [];
            if ((0, _isEmpty2.default)((0, _item.getItem)(state, itemId))) {
                promises.push(dispatch((0, _item.fetchItemsIfNeeded)([itemId])));
            }
            return _promise2.default.all(promises).then(function () {
                var newState = getState();
                var savedItemAnalytics = (0, _analytics.getSaveItemAnalytics)(newState, itemId);
                dispatch(saveItemSuccess(itemId, savedItemAnalytics));
            });
        }).catch(function (error) {
            dispatch(saveItemFail(itemId, error));
        });
    };
};

var unsaveItemFail = function unsaveItemFail(itemId, error) {
    return {
        error: true,
        meta: { itemId: itemId },
        payload: error,
        type: UNSAVE_ITEM_FAIL
    };
};

var unsaveItemRequest = function unsaveItemRequest(itemId) {
    return {
        payload: itemId,
        type: UNSAVE_ITEM_REQUEST
    };
};

var unsaveItemSuccess = function unsaveItemSuccess(itemId, unsavedItemAnalytics) {
    return {
        meta: unsavedItemAnalytics,
        payload: itemId,
        type: UNSAVE_ITEM_SUCCESS
    };
};

var submitUnsaveItem = function submitUnsaveItem(itemId) {
    return function (dispatch, getState) {
        var state = getState();
        var authToken = (0, _user.getAuthToken)(state);
        var deployment = (0, _config.getDeployment)(state);
        dispatch(unsaveItemRequest(itemId));
        return _api.SaveItem.postUnsaveItem({ authToken: authToken, deployment: deployment, itemId: itemId }).then(function () {
            var promises = [];
            if ((0, _isEmpty2.default)((0, _item.getItem)(state, itemId))) {
                promises.push(dispatch((0, _item.fetchItemsIfNeeded)([itemId])));
            }
            return _promise2.default.all(promises).then(function () {
                var unsavedItemAnalytics = (0, _analytics.getUnsaveItemAnalytics)(getState(), itemId);
                dispatch(unsaveItemSuccess(itemId, unsavedItemAnalytics));
            });
        }).catch(function (error) {
            dispatch(unsaveItemFail(itemId, error));
        });
    };
};

var toggleItemSave = exports.toggleItemSave = function toggleItemSave(itemId) {
    return function (dispatch, getState) {
        if (isItemSaved(getState(), itemId)) {
            return dispatch(submitUnsaveItem(itemId));
        } else {
            return dispatch(submitSaveItem(itemId));
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/saveItem.js
// module id = 6oKK
// module chunks = 46